/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';
@use '../../../../mixins';

.measures-defibrillation {
  .defibrillation-wireframe {
    @include mixins.page-grid-basics;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      '. .'
      '. .';
  }

  .subheader {
    margin-bottom: variables.$margin-medium;
    margin-top: variables.$margin-medium;
  }
}
